import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Problems() {
  return (
    <section className="intro_section p-100">
      <Container>
        <Row>
          <Col xs={12} md={12} lg={5} xl={5} xxl={5} className="my-auto ">
            <h2 style={{ color: "#000" }}>
              The <span style={{ color: "#75CB4C" }}>Problem</span>
            </h2>
            <p>
              Along with a minimalistic design and a user-oriented interface,
              the client required a calculator integrated within the website
              that can help users compare plans from different energy suppliers
              and make better, more informed decisions.
            </p>
          </Col>
          <Col
            xs={12}
            md={12}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto text-center offset-lg-1 "
          >
            <StaticImage
              src="../../../images/case-studies/dream-energy/problem_img.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={1712}
              height={882}
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Problems;
